import type { FeaturedProductsData } from '@/data/types';
import featuredProductsData from '@/data/featuredProducts.json';

export function useFeaturedProductsData(): { featuredProductsData: FeaturedProductsData } {
  return { featuredProductsData: featuredProductsData as FeaturedProductsData };
}